import { PropTypes as MobxPropTypes, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownItem } from 'reactstrap';

import globalTranslations from '../../../i18n/globalTranslations';
import Currency from '../../../models/Currency';
import { modelOf } from '../../../prop-types';
import DropdownSelect from '../../common/DropdownSelect';
import CurrencyLabel from '../CurrencyLabel';

const RegionalSettingsCurrencyDropdown = ({
  currency,
  currencies,
  onSelect,
  disabled: disabledProp,
}) => {
  const disabled = currencies.length < 2 ? true : disabledProp;

  return (
    <DropdownSelect
      className="RegionalSettingsCurrencyDropdown"
      label={
        <FormattedMessage
          {...globalTranslations.currencyLabel}
          values={{
            currency: currency.code,
          }}
        />
      }
      disabled={disabled}
      focusSelectedItemOnKeyboardOpen
      focusToggleOnClose
    >
      {currencies.map((currencyOption) => {
        const isActive = currencyOption.code === currency.code;

        return (
          <DropdownItem
            onClick={() => onSelect(currencyOption)}
            key={currencyOption.code}
            active={isActive}
            aria-current={isActive ? 'true' : undefined}
          >
            <CurrencyLabel currency={currencyOption} />
          </DropdownItem>
        );
      })}
    </DropdownSelect>
  );
};

RegionalSettingsCurrencyDropdown.propTypes = {
  currency: modelOf(Currency).isRequired,
  currencies: MobxPropTypes.arrayOrObservableArrayOf(modelOf(Currency))
    .isRequired,
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

RegionalSettingsCurrencyDropdown.defaultProps = {
  disabled: false,
};

export default observer(RegionalSettingsCurrencyDropdown);
